import { _itmAxios } from "@/plugins/itmAxios";

const getItmSugangStatus = (code) => {
  return _itmAxios.get(`/external/sugang/main/status?code=${code}`);
};

const sugangQaApi = (pageIdx, body) => {
  return _itmAxios.post(`/external/sugang/qa/${pageIdx}`, body);
};

const itmSugangCodeInfo = (code) => {
  return _itmAxios.get(`/external/sugang/main/status?code=${code}`);
};

const itmSugangPgmList = (pgmIdx) => {
  return _itmAxios.get(`/external/sugang/select-program/${pgmIdx}`);
};

const itmSumaryInfo = (pageIdx) => {
  return _itmAxios.get(`/external/sugang/summary/${pageIdx}`);
};

const agreeInfo = (mainIdx) => {
  return _itmAxios.get(`/external/sugang/agree/${mainIdx}`);
};

const itmProgramInfo = (email, programIdx) => {
  return _itmAxios.get(`/external/program/${programIdx}?email=${email}`);
};

const itmProgramSearch = (classIdx, query) => {
  return _itmAxios.get(`/external/program/search-subject/${classIdx}`, {
    params: query,
  });
};

const itmPayCheck = (email, body) => {
  return _itmAxios.post(`/external/pay/check?email=${email}`, body);
};

const itmSugangInfo = (email, pageIdx) => {
  return _itmAxios.get(`/external/sugang/info/${pageIdx}?email=${email}`);
};

const itmApplySugang = (sugang) => {
  return _itmAxios.post(`/external/sugang/apply`, sugang);
};

const applyHistory = (pageIdx, email) => {
  return _itmAxios.get(`/external/apply-history/${pageIdx}?email=${email}`);
};

const requestPayment = async (email, list) => {
  return _itmAxios.post(`/external/pay/check?email=${email}`, list);
};

const completeSugangInfo = (mainIdx) => {
  return _itmAxios.get(`/external/sugang/complete/${mainIdx}`);
};

const cancelClass = (email, studentSubjectIdx) => {
  return _itmAxios.post(`/external/cancel/${studentSubjectIdx}?email=${email}`);
};
// 추가 개발건으로 인해 메인에서 삭제를 해야해서 기존API 호출명이 CTM과 동일하여 새로 생성
const itmCancelClass = (email, studentSubjectIdx) => {
  return _itmAxios.post(`/external/cancel/${studentSubjectIdx}?email=${email}`);
};

const payConfirm = (impUid, orderId) => {
  return _itmAxios.post(
    `/external/pay/confirm?impUid=${impUid}&orderId=${orderId}`
  );
};

const subjectDup = (body) => {
  return _itmAxios.post(`/external/check-subjectdup`, body);
};

const chooseProgram = (programIdx, email) => {
  return _itmAxios.get(`/external/choose-program/${programIdx}`, {
    params: {
      email,
    },
  });
};
const checkTmp = (sugang) => {
  console.log(sugang)
  return _itmAxios.post(`/external/sugang/new/checkTmp`, sugang);
};
const newApply = (sugang) => {
  return _itmAxios.post(`/external/sugang/new/apply`, sugang);
};
const itmApplyHistory = (programIdx, params) => {
  return _itmAxios.get(`external/apply-history/${programIdx}`, {
    params,
  });
};

export {
  getItmSugangStatus,
  sugangQaApi,
  itmSugangCodeInfo,
  itmSugangPgmList,
  itmSumaryInfo,
  agreeInfo,
  checkTmp,
  itmProgramInfo,
  itmProgramSearch,
  itmPayCheck,
  itmSugangInfo,
  itmApplySugang,
  applyHistory,
  requestPayment,
  completeSugangInfo,
  cancelClass,
  payConfirm,
  subjectDup,
  chooseProgram,
  newApply,
  itmApplyHistory,
  itmCancelClass,
};
